<p>lookup-category-add works!</p>
